/**
 * DS Lexicon Component
 * 
 * This script handles the filtering functionality for the lexicon items
 * when clicking on the label navigation buttons.
 */

class DSLexicon {
  constructor(container) {
    this.container = container;
    this.sectionId = this.container.dataset.sectionId;
    this.navigationButtons = this.container.querySelectorAll('.ds-lexicon-navigation .button');
    this.lexiconItems = this.container.querySelectorAll('.ds-lexicon');
    
    this.init();
  }

  init() {
    // Add event listeners to navigation buttons
    if (this.navigationButtons.length > 0) {
      this.navigationButtons.forEach(button => {
        button.addEventListener('click', this.handleButtonClick.bind(this));
      });
    }
  }

  handleButtonClick(event) {
    event.preventDefault();
    
    // Remove active class from all buttons
    this.navigationButtons.forEach(button => {
      button.classList.remove('button--primary');
      button.classList.add('button--secondary');
    });
    
    // Add active class to clicked button
    event.currentTarget.classList.remove('button--secondary');
    event.currentTarget.classList.add('button--primary');
    
    const selectedLabel = event.currentTarget.textContent.trim();
    this.filterItems(selectedLabel);
  }

  filterItems(selectedLabel) {
    // If "All" is selected, show all items
    const showAll = selectedLabel === 'All' || selectedLabel === 'Alle';
    
    // First, show all categories and items if "All" is selected
    if (showAll) {
      this.lexiconItems.forEach(item => {
        item.style.display = '';
      });
      
      // Show all category headings
      const categoryHeadings = this.container.querySelectorAll('.ds-lexicon-category');
      categoryHeadings.forEach(heading => {
        heading.style.display = '';
      });
      
      return;
    }
    
    // For specific label filtering
    // First, hide all items and track which categories have visible items
    const categoriesWithVisibleItems = new Set();
    
    // Loop through all items and show/hide based on the selected label
    this.lexiconItems.forEach(item => {
      const itemLabel = item.dataset.label;
      
      if (itemLabel === selectedLabel) {
        item.style.display = '';
        // Track which category this item belongs to
        const categoryList = item.closest('.ds-lexicon-list');
        if (categoryList) {
          const categoryHeading = categoryList.previousElementSibling;
          if (categoryHeading && categoryHeading.classList.contains('ds-lexicon-category')) {
            categoriesWithVisibleItems.add(categoryHeading);
          }
        }
      } else {
        item.style.display = 'none';
      }
    });
    
    // Now hide all category headings that don't have visible items
    const allCategoryHeadings = this.container.querySelectorAll('.ds-lexicon-category');
    allCategoryHeadings.forEach(heading => {
      if (categoriesWithVisibleItems.has(heading)) {
        heading.style.display = '';
      } else {
        heading.style.display = 'none';
      }
    });
  }
}

// Initialize the component when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  const lexiconSections = document.querySelectorAll('.shopify-section--ds-lexicon');
  
  lexiconSections.forEach(section => {
    new DSLexicon(section);
  });
});

// Re-initialize when the section is reloaded via Shopify's section rendering
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('shopify-section--ds-lexicon')) {
    new DSLexicon(event.target);
  }
});
